import React from "react";
import PropTypes from "prop-types";

import { processHtmlLinks } from "../../../../utils/html-utils";
import './TextElement.m.css';

const decodeEntities = (text) => {
  if (typeof window !== "undefined" && typeof document !== "undefined") {
    const textarea = document.createElement("textarea");
    textarea.innerHTML = text;
    return textarea.value;
  }
  return text
    .replace(/&amp;/g, '&')
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/&quot;/g, '"')
    .replace(/&#39;/g, "'")
    .replace(/&nbsp;/g, ' ');
};

const processContent = (html, { isLeadershipFocus, subtype } = {}) => {
  if (typeof html !== "string") return "";
  let processedHtml = html;

  processedHtml = processedHtml.replace(/<h2([^>]*)>(.*?)<\/h2>/gi, (match, attrs, content) => {
    const rawTextContent = content.replace(/<[^>]*>/g, "").trim();
    const textContent = decodeEntities(rawTextContent);
    const id = textContent.toLowerCase().replace(/\s+/g, "-").replace(/[^\w-]/g, "");
    const hasId = /id\s*=/.test(attrs);
    return hasId ? match : `<h2${attrs} id="${id}">${content}</h2>`;
  });

  const targetTag = isLeadershipFocus && subtype === "question" ? "h4" : "h3";

  processedHtml = processedHtml.replace(/<h3([^>]*)>(.*?)<\/h3>/gi, (match, attrs, content) => {
    const rawTextContent = content.replace(/<[^>]*>/g, "").trim();
    const textContent = decodeEntities(rawTextContent);
    const id = textContent.toLowerCase().replace(/\s+/g, "-").replace(/[^\w-]/g, "");
    const hasId = /id\s*=/.test(attrs);
    return hasId ? `<${targetTag}${attrs}>${content}</${targetTag}>` : `<${targetTag}${attrs} id="${id}">${content}</${targetTag}>`;
  });

  processedHtml = processHtmlLinks(processedHtml);

  return processedHtml;
};

const TextElement = ({ element, useBrandColour, isLeadershipFocus, usePartnershipStyle = false }) => {
  if (!element) return null;
  const { text, subtype } = element;

  if (subtype === "also-read") return null;

  const processedText = processContent(text, { isLeadershipFocus, subtype });

  const classNames = [
    "story-element",
    "text-element",
    useBrandColour ? "brand-colour-card" : "",
    usePartnershipStyle ? "partnership-style" : "",
    isLeadershipFocus ? "leadership-focus-text" : "",
    subtype === "summary" ? "summary-text" : ""
  ].filter(Boolean).join(" ");

  return (
    <div
      styleName={classNames}
      dangerouslySetInnerHTML={{ __html: processedText }}
    />
  );
};

TextElement.propTypes = {
  element: PropTypes.object.isRequired,
  useBrandColour: PropTypes.bool,
  usePartnershipStyle: PropTypes.bool,
  isLeadershipFocus: PropTypes.bool,
};

export default TextElement;
